import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M20 3.333a16.667 16.667 0 1 0 0 33.334 16.667 16.667 0 0 0 0-33.334m0 3.334A13.333 13.333 0 0 1 33.333 20c0 4-1.666 7.5-4.5 10-2.333-2.167-5.5-3.333-8.833-3.333S13.667 27.833 11.167 30c-2.834-2.5-4.5-6-4.5-10A13.333 13.333 0 0 1 20 6.667m3.333 3.15c-.633.016-1.233.433-1.5 1.083l-2.15 5.383-.166.384a3.48 3.48 0 0 0-2.617 2.1 3.33 3.33 0 0 0 1.867 4.333 3.33 3.33 0 0 0 4.333-1.867c.433-1.1.233-2.366-.483-3.3l.166-.433 2.15-5.35.017-.05a1.685 1.685 0 0 0-.933-2.167 1.8 1.8 0 0 0-.684-.116M16.667 10a1.667 1.667 0 1 0 0 3.333 1.667 1.667 0 0 0 0-3.333m-5 5a1.667 1.667 0 1 0 0 3.333 1.667 1.667 0 0 0 0-3.333m16.666 0a1.667 1.667 0 1 0 0 3.334 1.667 1.667 0 0 0 0-3.334"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }